import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { ThemeToggle } from "../shared/ThemeToggle";
import { useAuth } from "../../lib/auth";

export const PublicNavbar = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  return (
    <header className="sticky top-0 z-50 backdrop-blur-xl bg-[hsl(var(--background))]/80 border-b border-border">
      <div className="max-w-[1280px] mx-auto px-6 md:px-8 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2.5" data-testid="logo-home">
          <div className="h-7 w-7 flex items-center justify-center border border-[hsl(var(--gold))] rounded-sm">
            <span className="font-display font-bold text-[10px] tracking-tight gold-text">FT</span>
          </div>
          <div className="leading-tight">
            <div className="font-display font-medium text-sm tracking-tight">FRONTERA</div>
            <div className="text-[9px] text-muted-foreground tracking-[0.2em] uppercase">Intelligence</div>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-8 text-sm text-muted-foreground">
          <a href="#what-you-get" className="hover:text-foreground transition-colors" data-testid="nav-what-you-get">What You Get</a>
          <a href="#sample" className="hover:text-foreground transition-colors" data-testid="nav-sample">Sample</a>
          <a href="#pricing" className="hover:text-foreground transition-colors" data-testid="nav-pricing">Pricing</a>
          <a href="#who-its-for" className="hover:text-foreground transition-colors" data-testid="nav-who-its-for">Who It's For</a>
        </nav>

        <div className="flex items-center gap-3">
          <ThemeToggle />
          {user ? (
            <button className="btn-primary" onClick={() => navigate("/dashboard")} data-testid="nav-dashboard-button">
              Dashboard <ArrowRight className="h-4 w-4" />
            </button>
          ) : (
            <>
              <button
                onClick={() => navigate("/auth")}
                className="hidden sm:block text-sm text-muted-foreground hover:text-foreground"
                data-testid="nav-login-button"
              >
                Log in
              </button>
              <button className="btn-primary" onClick={() => navigate("/auth")} data-testid="nav-request-access-button">
                Request Access <ArrowRight className="h-4 w-4" />
              </button>
            </>
          )}
        </div>
      </div>
    </header>
  );
};
